<div class="modal-header mb-10">
  <div class="modal-title">
    <h3 class="d-inline-block">{{title}}</h3>
    <button type="button" class="btn-close" (click)="dialogRef.close(false)">
      <span class="icon-close"></span>
    </button>
  </div>
</div>

<div class="modal-body">
  <p>{{message}}</p>
</div>

<div class="modal-footer pt-15 d-flex justify-content-between align-items-center">
  <a role="button" class="btn btn-outline-dark" (click)="onCancelClick()">{{cancelText}}</a>
  <button class="btn btn-primary" type="submit" (click)="onSubmitClick()">{{confirmText}}</button>
</div>
